import lock_icon from '../../styles/img/lock2.svg';

export default function PikkoJackpotLock({ price }) {
    return(
        <div className="flex w-full py-4 px-6 bg-[#FCFAFE] rounded-[0.4em] items-center gap-4">
            <img src={lock_icon} alt="lock" className='w-6 object-contain' />
            <div className='flex w-full items-center'>
                <p className="geomanistBook text-2xl text-[#8130EC]">
                    <span className="text-[#8130EC] geomanistMedium text-2xl"> +{price} </span>
                    sera ajouté à ta cagnotte
                </p>
            </div>

        </div>
    )
}
